var nanobus = require( 'nanobus' );

export default class ScreenOption {
	constructor( element ) {
		this.element = element;
		this.state = false;
		this.events = new nanobus();

		this.init();
	}

	init() {
		this.determinScreenOptionState();

		this.element.addEventListener( 'click', () => {
			this.determinScreenOptionState();
			this.persist();
		} );
	}

	isEnabled() {
		return this.element.checked;
	}

	determinScreenOptionState() {
		if ( this.isEnabled() ) {
			this.enable();
		} else {
			this.disable();
		}
	}

	enable() {
		this.state = true;
		this.events.emit( 'changeState', true );
	}

	disable() {
		this.state = false;
		this.events.emit( 'changeState', false );
	}

	persist() {
		jQuery.post( ajaxurl, {
			action : 'acp_new_inline_show_button',
			value : this.state,
			layout : AC.layout,
			list_screen : AC.list_screen,
			_ajax_nonce : AC.ajax_nonce
		} );
	}

}